import { AbstractControl, ValidatorFn } from '@angular/forms';

export const PasswordPatternValidator: ValidatorFn = (control: AbstractControl): { [key: string]: unknown } | null => {
    const password = control?.value;
    return !!password &&
        password.length >= 8 &&
        password.search(/[a-z]/) > -1 &&
        password.search(/[A-Z]/) > -1 &&
        password.search(/[0-9]/) > -1
        ? null
        : { notValid: true };
};
